import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddPosition = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z",
		fill: "#000"
	})]
});
const ForwardRef = forwardRef(SvgAddPosition);
export { ForwardRef as ReactComponent };
